import { parseJson, stringify } from "./utils";

export const jsonStorage = new Proxy(localStorage, {
	get(target, p, receiver) {
		const value = target.getItem(p.toString());
		return parseJson(value);
	},
	set(target, p, newValue, receiver) {
		target.setItem(p.toString(), stringify(newValue));
		return true;
	},
});
